import React, { useState }from 'react';
import Table from 'react-bootstrap/Table'
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import './StudentTable.css';

const unitSpcs = require('../../utils/UnitSpcJson');
const units = require('../../utils/UnitJson');
const spcs = require('../../utils/SpcJson');

export default function StudentTable({ students }) {
  const [unitCount, setUnitCount] = useState(students.length);
  const [spcCount, setSpcCount] = useState(students.length);
  const [unitSpcCount, setUnitSpcCount] = useState();

  const columns = [
        {
          dataField: 'index',
          headerClasses: 'index',
          text: '#',
          sort: true
        }, {
          dataField: 'rankAbbrName',
          headerClasses: 'rank-abbr-name',
          text: 'ยศ',
          sort: true
        }, {
          dataField: 'fullName',
          headerClasses: 'full-name',
          text: 'ชื่อ-นามสกุล',
          filter: textFilter()
        }, {
          dataField: 'unit_no',
          headerClasses: 'org-abbr-name',
          text: `นขต.ทอ. ${unitCount != students.length ? '('+unitCount+')' : ''}`,
          formatter: cell => units[cell],
          filter: selectFilter({
            options: units,
            onFilter: (filterValue, rows) => {
              const filter = rows.filter(e => e.unit_no == filterValue);
              setUnitCount(filter.length);
              if(filterValue == '') setUnitCount(students.length);
            }
          })
        }, {
          dataField: 'unitSpcNo',
          headerClasses: 'unit-spc-no',
          text: `หน่วย หน.สายวิทยาการ ${(unitSpcCount != students.length && unitSpcCount != undefined) ? '('+unitSpcCount+')' : ''}`,
          formatter: cell => unitSpcs[cell],
          filter: selectFilter({
            options: unitSpcs,
            onFilter: (filterValue, rows) => {
              const filter = rows.filter(e => e.unitSpcNo == filterValue);
              setUnitSpcCount(filter.length);
              if(filterValue == '') setUnitSpcCount(students.length);
            }
          })
      }, {
        dataField: 'spcNo',
        headerClasses: 'spc-name',
        text: `สายวิทยาการ ${spcCount != students.length ? '('+spcCount+')' : ''}`,
        formatter: cell => spcs[cell],
        filter: selectFilter({
          options: spcs,
          onFilter: (filterValue, rows) => {
            const filter = rows.filter(e => e.spcNo == filterValue);
            setSpcCount(filter.length);
            if(filterValue == '') setSpcCount(students.length);
          }
        })
      }, {
        dataField: 'age',
        headerClasses: 'age',
        text: 'อายุ',
        sort: true
      }, {
        dataField: 'seniorOfRank',
        headerClasses: 'senior-of-rank',
        text: 'ระยะเวลาการครองยศ',
        sort: true
      }, {
        dataField: 'ecl_score',
        headerClasses: 'ecl-score',
        text: 'คะแนนภาษาอังกฤษ',
        sort: true
      }
  ];

    return (
      <div className="table-list">
        {students.length > 0 && <div className='container'>
          <BootstrapTable
            striped 
            hover 
            bordered={ false } 
            keyField='id' 
            data={ students }
            columns={ columns } 
            filter={ filterFactory() }
            noDataIndication='-----ไม่พบข้อมูล-----'
            bootstrap4
            classes='student-course-table'
          />
        </div>}
      </div>
    );
}